// frontend/src/components/dataCatalog/tabs/MetricsTab.js
import React, { useState } from "react";
import { newtonsCradle } from "ldrs";
import { CategoryButton } from "../components/CategoryButton";
import { FeatureButton } from "../components/FeatureButton";
import { BackButton } from "../components/BackButton";
import { useFeatureNavigation } from "../../../util/dataCatalog/useFeatureNavigation";
import { useFetchFeatures } from "../../../util/useFetchFeatures";
import { filterFeatures } from "../../../util/dataCatalog/filterFeatures";
import { CatalogSearchBar } from "../components/CatalogSearchBar";
import { FeatureTypeConfig } from "../config/featureTypes";
import { MetricCard } from "../components/MetricCard";

newtonsCradle.register();

const MetricsTab = ({ onMetricSelect, isItemSelected }) => {
  const {
    selectedCategory,
    selectedFeature,
    handleCategoryClick,
    handleFeatureClick,
    handleBack,
    handleDirectCategoryAndFeature,
    isDirectNavigation,
  } = useFeatureNavigation();

  const [searchTerm, setSearchTerm] = useState("");

  const { categorizedFeatures, isLoading } = useFetchFeatures(
    "/api/config/metrics"
  );
  const filteredFeatures = filterFeatures(categorizedFeatures, searchTerm);

  const handleMetricSelection = (metricItem) => {
    onMetricSelect(metricItem);
  };

  const handleBackWithValue = () => {
    handleBack();
  };

  const handleCategoryOrFeatureClick = (category, features) => {
    if (
      features.length === 1 &&
      features[0].name === category &&
      features[0].type !== "estimate"
    ) {
      handleDirectCategoryAndFeature(category, features[0]);
    } else {
      handleCategoryClick(category);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <l-newtons-cradle
          size="120"
          speed="1.4"
          color="black"
        ></l-newtons-cradle>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {!selectedFeature && (
        <CatalogSearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      )}
      {selectedCategory && (
        <BackButton
          onClick={handleBackWithValue}
          backTarget={
            selectedFeature && !isDirectNavigation
              ? selectedCategory
              : "Categories"
          }
        />
      )}

      {!selectedCategory ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {Object.entries(filteredFeatures).map(([category, features]) => (
            <CategoryButton
              key={category}
              category={category}
              onClick={() => handleCategoryOrFeatureClick(category, features)}
            />
          ))}
        </div>
      ) : !selectedFeature ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {filteredFeatures[selectedCategory]?.map((feature) => {
            if (feature.type === "continuous") {
              return (
                <MetricCard
                  key={feature.name}
                  title={feature.display || feature.name}
                  description={feature.description}
                  options={feature.available_aggregations}
                  onOptionSelect={(agg) => {
                    const metricItem = FeatureTypeConfig[
                      feature.type
                    ].createMetricItem(feature, agg);
                    handleMetricSelection(metricItem);
                  }}
                  isOptionSelected={(agg) => {
                    const metricItem = FeatureTypeConfig[
                      feature.type
                    ].createMetricItem(feature, agg);
                    return isItemSelected(metricItem, "metrics");
                  }}
                />
              );
            }
            if (feature.type === "estimate") {
              console.log(feature);
              return (
                <MetricCard
                  key={feature.name}
                  title={feature.display || feature.name}
                  description={feature.description}
                  options={feature.years}
                  onOptionSelect={(year) => {
                    const metricItem = FeatureTypeConfig[
                      feature.type
                    ].createMetricItem(feature, year);
                    handleMetricSelection(metricItem);
                  }}
                  isOptionSelected={(year) => {
                    const metricItem = FeatureTypeConfig[
                      feature.type
                    ].createMetricItem(feature, year);
                    return isItemSelected(metricItem, "metrics");
                  }}
                />
              );
            }
            return (
              <FeatureButton
                key={feature.name}
                feature={feature.display || feature.name}
                description={feature.description}
                onClick={() => handleFeatureClick(feature)}
                selected={false}
              />
            );
          })}
        </div>
      ) : selectedFeature.type === "categorical" ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {selectedFeature.values?.map((value, idx) => (
            <MetricCard
              key={value}
              title={selectedFeature.display_values[idx]}
              options={selectedFeature.available_aggregations}
              onOptionSelect={(agg) => {
                const metricItem = FeatureTypeConfig[
                  selectedFeature.type
                ].createMetricItem(selectedFeature, agg, {
                  key: value,
                  value: selectedFeature.display_values[idx],
                });
                handleMetricSelection(metricItem);
              }}
              isOptionSelected={(agg) => {
                const metricItem = FeatureTypeConfig[
                  selectedFeature.type
                ].createMetricItem(selectedFeature, agg, {
                  key: value,
                  value: selectedFeature.display_values[idx],
                });
                return isItemSelected(metricItem, "metrics");
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export { MetricsTab };
